import type { RootState } from 'core/store';
import type { Cart, Catalog } from 'core/domains';

type Item = Catalog['data'][number] &
  Cart['data']['items'][number] &
  Cart['data']['pointsPrograms'][number];

/**
 * Return object items from context cart
 *
 */
const getCartItems = ({ data: { items = [], pointsPrograms = [] } }: Cart) => {
  if (pointsPrograms.length) {
    return [...items, ...(pointsPrograms[0] || {}).availableItems] as Item[];
  }

  return items;
};

/**
 * Return product information to build the dataLayer
 *
 */
export function getProduct(state: RootState, code: string) {
  const {
    cart,
    catalog: { data: catalogItems },
    search: { data: searchItems },
    showcases,
  } = state;
  const showcasesItems =
    showcases.data?.flatMap((showcase) => showcase.data) || ([] as Catalog['data']);

  return [...showcasesItems, ...catalogItems, ...getCartItems(cart), ...searchItems].find(
    (item) => item.productCode === code,
  ) as Item;
}
